(function () {
  function init() {
    var ban = document.querySelector('.sph-accban');
    var acc = document.getElementById('sph-acc') || document.querySelector('.sph-acc');
    if (ban) {
      var banSec = ban.closest('.shopify-section') || ban;
      if (!acc) { banSec.remove(); return; }
      var payBox = document.querySelector('.sph-paytrust') || document.querySelector('.sph-pay');
      if (!payBox) {
        var alerts = document.querySelectorAll('[data-sph-product] .sph-buycol .sph-alert');
        if (alerts.length) payBox = alerts[alerts.length - 1];
      }
      var inner = ban.querySelector('.sph-accban__in');
      if (payBox && inner) {
        var wrap = document.createElement('div');
        wrap.className = 'sph sph-accban';
        wrap.style.margin = '12px 0 0';
        wrap.appendChild(inner);
        payBox.insertAdjacentElement('afterend', wrap);
        banSec.remove();
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
